"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Data for each product consumed by Google Analytics tracking
 *
 * @name ProductData
 * @param {Object} params
 * @param {string} params.id - The product ID or SKU (e.g. P67890). *Either this field or name must be set.
 * @param {string} params.name - The name of the product (e.g. Android T-Shirt). *Either this field or id must be set.
 * @param {string} [params.brand] - The brand associated with the product (e.g. Google).
 * @param {string} [params.category] - The category to which the product belongs (e.g. Apparel). Use / as a delimiter to specify up to 5-levels of hierarchy (e.g. Apparel/Men/T-Shirts).
 * @param {string} [params.variant] - The variant of the product (e.g. Black).
 * @param {number} [params.price] - The price of a product (e.g. 29.20).
 * @param {number} [params.quantity] - The quantity of a product (e.g. 2).
 * @param {string} [params.coupon] - The coupon code associated with a product (e.g. SUMMER_SALE13).
 * @param {number} [params.position] - The product's position in a list or collection (e.g. 2).
 */
var ProductData = function ProductData(params) {
    _classCallCheck(this, ProductData);

    Object.assign(this, params);
};

exports.default = ProductData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/dataTypes/ProductData.js
// module id = 335
// module chunks = 0